import { render, staticRenderFns } from "./MaldicaoEterna.vue?vue&type=template&id=52d6a138&"
import script from "./MaldicaoEterna.vue?vue&type=script&lang=js&"
export * from "./MaldicaoEterna.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports